export default "__VITE_ASSET__a8a5a0c1__"